<div class="chatbot-wrapper" [class.chatbot-wrapper--open]="isOpen">
  <button
    mat-fab
    color="primary"
    class="chatbot-toggle"
    (click)="toggle()"
    aria-label="Toggle MPS Copilot"
  >
    <mat-icon *ngIf="!isOpen">smart_toy</mat-icon>
    <mat-icon *ngIf="isOpen">close</mat-icon>
  </button>

  <div
    class="chat-panel"
    *ngIf="isOpen"
    [style.width.px]="panelWidth"
    [style.height.px]="panelHeight"
  >
    <div class="chat-panel__header">
      <div>
        <p class="chat-panel__eyebrow">MPS Copilot · Preview</p>
        <h4 class="chat-panel__title">VSMPS-AI Procurement Assistant</h4>
      </div>
      <span class="chat-panel__status">
        <span class="dot"></span>
        Available
      </span>
    </div>

    <div class="chat-panel__body" #messageScroll>
      <div
        *ngFor="let message of messages"
        class="chat-message"
        [class.chat-message--user]="message.role === 'user'"
      >
        <div class="chat-message__avatar" *ngIf="message.role !== 'user'">
          <mat-icon>smart_toy</mat-icon>
        </div>
        <div class="chat-message__avatar chat-message__avatar--user" *ngIf="message.role === 'user'">
          <mat-icon>person</mat-icon>
        </div>
        <div class="chat-message__bubble" [attr.data-tone]="message.tone">
          <p>{{ message.content }}</p>
          <div *ngIf="message.steps?.length" class="steps-list">
            <div
              class="step-item"
              *ngFor="let step of message.steps; let i = index"
              [style.animationDelay.ms]="i * 90"
            >
              <span class="step-number">{{ i + 1 }}</span>
              <span class="step-text">{{ step }}</span>
            </div>
          </div>
          <div *ngIf="message.cta === 'notifications'" class="cta-row">
            <button class="link-button" (click)="openNotifications()">View all notifications</button>
          </div>
          <div *ngIf="message.cta === 'products'" class="cta-row">
            <button class="link-button" (click)="openProducts()">Go to product page</button>
          </div>
          <div *ngIf="message.link" class="cta-row">
            <button class="link-button" (click)="navigateLink(message.link)">{{ message.link.label }}</button>
          </div>
          <span class="timestamp">{{ message.timestamp | date: 'shortTime' }}</span>
        </div>
      </div>

      <div class="chat-message chat-message--assistant" *ngIf="isThinking">
        <div class="chat-message__avatar">
          <mat-icon>smart_toy</mat-icon>
        </div>
        <div class="chat-message__bubble typing">
          <div class="typing-text" *ngIf="thinkingMessage">{{ thinkingMessage }}</div>
          <span *ngFor="let dot of typingDots; let i = index" [class.active]="i === activeDotIndex"></span>
        </div>
      </div>
    </div>

    <div class="chat-panel__footer">
      <form class="chat-input" (ngSubmit)="submitPrompt()">
        <div class="chat-editor-wrapper">
          <div
            #editorBox
            class="chat-editor"
            contenteditable="true"
            role="textbox"
            [attr.data-placeholder]="'Procurement at your fingertips'"
            (input)="onEditorInput($event)"
            (keydown.enter)="handleEnter($event)"
          ></div>
          <button
            mat-icon-button
            color="primary"
            type="submit"
            [disabled]="promptControl.invalid || isThinking"
            aria-label="Send prompt"
            class="send-button"
          >
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </form>

      <div class="quick-actions">
        <!-- <span>Suggested prompts:</span> -->
        <button
          mat-stroked-button
          color="primary"
          *ngFor="let prompt of quickPrompts"
          (click)="runQuickPrompt(prompt.id, prompt.prompt)"
        >
          {{ prompt.label }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          class="quick-actions__toggle"
          (click)="toggleQuickActions()"
        >
          Quick actions
        </button>
      </div>
      <div class="quick-actions-list" *ngIf="showQuickActions && quickActions.length">
        <button
          mat-button
          type="button"
          *ngFor="let action of quickActions"
          (click)="runQuickPrompt(action.id, action.prompt)"
        >
          {{ action.label }}
        </button>
      </div>
    </div>
    <!-- <button
      class="chat-panel__resize-handle"
      type="button"
      aria-label="Resize chatbot"
      (mousedown)="startResize($event)"
    >
      <mat-icon>open_in_full</mat-icon>
    </button> -->
  </div>
</div>
